import {ActivityKind} from 'modules/activity/models';
import {ICoursePreview} from '.';


export const futureFoundersPreview: ICoursePreview = {
    id: 6318886555222016,
    name: 'Future Founders – Kickstarter Course',
    description: 'Choose from two versions: primary school or high school. Signup now to access the Future Founders Kickstarter Course.',
    imgSRC: '/assets/images/LandingPage/CoursesSection/Future-Founders-banner.png',
    details: {
        subject_area: 'Entrepreneurship, Business',
        suggested_duration: '10 Weeks - 1hr/week',
        resources_required: 'N/A',
        cost: 'Unlock all modules for $29.95',
    },
    activities: [
        {
            name: 'Module 1: Entrepreneurial Mindset',
            kind: ActivityKind.ACTIVITY,
            locked: false,
        },
        {
            name: 'Module 2: Problems & Solutions',
            kind: ActivityKind.ACTIVITY,
            locked: false,
        },
        {
            name: 'Module 3: Business Model Canvas',
            kind: ActivityKind.ACTIVITY,
            locked: true,
        },
        {
            name: 'Module 4: Market Research',
            kind: ActivityKind.ACTIVITY,
            locked: true,
        },
        {
            name: 'Module 5: SWOT Analysis',
            kind: ActivityKind.ACTIVITY,
            locked: true,
        },
        {
            name: 'Module 6: Prototyping',
            kind: ActivityKind.ACTIVITY,
            locked: true,
        },
        {
            name: 'Module 7: Financial Foundations',
            kind: ActivityKind.ACTIVITY,
            locked: true,
        },
        {
            name: 'Module 8: Managing Risks',
            kind: ActivityKind.ACTIVITY,
            locked: true,
        },
        {
            name: 'Module 9: Building Your Brand',
            kind: ActivityKind.ACTIVITY,
            locked: true,
        },
        {
            name: 'Module 10: Refinement, Feedback & SMART Goals',
            kind: ActivityKind.ACTIVITY,
            locked: true,
        },
        {
            name: 'Bonus – How to Develop a Pitch',
            kind: ActivityKind.ACTIVITY,
            locked: false,
        },
        {
            name: 'Bonus – How to Deliver a Pitch',
            kind: ActivityKind.ACTIVITY,
            locked: false,
        },
    ],
};

// export const snakeGamePreview: ICoursePreview = {
//     id: 5186459170504704,
//     name: 'Build the classic game Snake! – Introduction to Game Development in p5.js',
//     shortName: 'Build the classic game Snake!',
//     description: 'Learn step-by-step how to build the classic Snake game using Javascript and the p5 animation library.',
//     imgSRC: '/assets/images/LandingPage/CoursesSection/Snake-Game-banner.png',
//     details: {
//         subject_area: 'Game Development, Programming',
//         suggested_duration: '6 hours',
//         resources_required: 'N/A',
//         cost: 'All Modules Free',
//     },
//     activities: [
//         {
//             name: 'Module 1: Introduction and Setting Up',
//             kind: ActivityKind.ACTIVITY,
//             locked: false,
//         },
//         {
//             name: 'Module 2: Creating the Snake Object',
//             kind: ActivityKind.ACTIVITY,
//             locked: false,
//         },
//         {
//             name: 'Module 3: Handling User Input and Changing Direction',
//             kind: ActivityKind.ACTIVITY,
//             locked: false,
//         },
//         {
//             name: 'Module 4: Implementing Food and Collision Detection',
//             kind: ActivityKind.ACTIVITY,
//             locked: false,
//         },
//         {
//             name: 'Module 5: Implementing Game Over Logic',
//             kind: ActivityKind.ACTIVITY,
//             locked: false,
//         },
//         {
//             name: 'Module 6: Going Forth, Student-Directed Feature Additions',
//             kind: ActivityKind.ACTIVITY,
//             locked: false,
//         },
//     ],
// };

// export const leanStartupPreview: ICoursePreview = {
//     id: 5680337099161600,
//     name: 'The Lean Startup Model - 2025',
//     description: 'Discover the secrets to launching and growing a successful startup with our Lean Startup Model course. Learn the proven methodology used by industry leaders to test, iterate, and scale innovative ideas efficiently. Master the art of validated learning, customer-centric product development, and sustainable growth strategies in just a few weeks.',
//     imgSRC: '/assets/images/LandingPage/CoursesSection/Lean-Startup-banner.png',
//     details: {
//         subject_area: 'Entrepreneurship, Business',
//         suggested_duration: '8 hours',
//         resources_required: 'N/A',
//         cost: 'All Modules Free',
//     },
//     activities: [
//         {
//             name: 'Module 1: Introduction to The Lean Startup Model',
//             kind: ActivityKind.ACTIVITY,
//             locked: false,
//         },
//         {
//             name: 'Module 2: Defining Your Startup',
//             kind: ActivityKind.ACTIVITY,
//             locked: false,
//         },
//         {
//             name: 'Module 3: Learning and Experimentation',
//             kind: ActivityKind.ACTIVITY,
//             locked: false,
//         },
//         {
//             name: 'Module 4: Pivoting and Persevering',
//             kind: ActivityKind.ACTIVITY,
//             locked: false,
//         },
//         {
//             name: 'Module 5: Minimum Viable Product (MVP)',
//             kind: ActivityKind.ACTIVITY,
//             locked: false,
//         },
//         {
//             name: 'Module 6: Metrics and Optimisation',
//             kind: ActivityKind.ACTIVITY,
//             locked: false,
//         },
//         {
//             name: 'Module 7: Growth and Adaptation',
//             kind: ActivityKind.ACTIVITY,
//             locked: false,
//         },
//         {
//             name: 'Module 8: Comprehensive Quiz - Assess Your Lean Startup Knowledge',
//             kind: ActivityKind.ACTIVITY,
//             locked: false,
//         },
//     ],
// };

export const currentCourses: ICoursePreview[] = [
    futureFoundersPreview,
    // snakeGamePreview,
    // leanStartupPreview,
];

// export const eCommerceCoursePreview: IUpcomingCoursePreview = {
//     name: 'Cart to Conversion: eCommerce Course',
//     cover: {
//         static_path: 'ecommerce',
//     },
// };

// export const SoftwareStartupCoursePreview: IUpcomingCoursePreview = {
//     name: 'Engineering Your First Software Startup',
//     cover: {
//         static_path: 'code',
//     },
// };

// export const AICoursePreview: IUpcomingCoursePreview = {
//     name: 'Your Guide to AI-Powered Business',
//     cover: {
//         static_path: 'ai',
//     },
// };

// export const upcomingCourses: IUpcomingCoursePreview[] = [
//     eCommerceCoursePreview,
//     SoftwareStartupCoursePreview,
//     AICoursePreview,
// ];